module.exports = __webpack_public_path__ + "img/img-video.198168a3.png";